import {
    Box,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import Colors from '../../../../../config/colors';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';

interface Props {
    isOpen: boolean;
    setIsOpenModal: (isOpen: boolean) => void;
    createCryptomusInvoice: () => void;
    setIsTonkeeper: (isTonkeeper: boolean) => void;
}

export default function SelectPaymentModal({
    isOpen,
    setIsOpenModal,
    createCryptomusInvoice,
    setIsTonkeeper,
}: Props) {
    const { t, i18n } = useTranslation();
    const initialRef = React.useRef(null);

    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const closeModal = () => {
        setIsOpenModal(false);
    };

    const selectTonkeeper = () => {
        setIsTonkeeper(true);
        closeModal();
    };

    // useEffect(() => {
    //     if (isSuccessEditUser) {
    //         window.open(redirectURL + '&email=' + email, '_self');
    //     }
    // }, [isSuccessEditUser]);

    return (
        <>
            <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={closeModal} isCentered>
                <ModalOverlay />
                <ModalContent m="8" background={Colors.darkBlue} color="#fff">
                    <ModalHeader fontWeight="300" color="#fff">
                        {t('select-payment-method')}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6} display="flex" flexDirection="column">
                        <Stack direction={['row']} spacing="14px">
                            <Box
                                display="flex"
                                flexDirection="column"
                                gap="9px"
                                alignItems="center"
                                width="100%"
                                onClick={() => selectTonkeeper()}>
                                <LazyLoadImage
                                    effect="blur"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/images/replenishment/tonkeeper.png'
                                    }
                                    style={{ borderRadius: '10px' }}
                                />
                                <Text fontSize="14px" color="#fff">
                                    Tonkeeper
                                </Text>
                            </Box>
                            <Box
                                display="flex"
                                flexDirection="column"
                                gap="9px"
                                alignItems="center"
                                width="100%"
                                onClick={() => createCryptomusInvoice()}>
                                <LazyLoadImage
                                    effect="blur"
                                    src={
                                        process.env.PUBLIC_URL +
                                        '/images/replenishment/cryptomus.png'
                                    }
                                    style={{ borderRadius: '10px' }}
                                />
                                <Text fontSize="14px" color="#fff">
                                    Cryptomus
                                </Text>
                            </Box>
                        </Stack>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
}
